import { SearchDrawer as View } from "ui-components";

import {
	useCloseMapTool,
	useCurrentSearchInput,
	useCurrentSearchType,
	useSetCurrentSearchInput,
	useSetCurrentSearchType,
} from "~map-view/states";

const RESULTS = [
	{ title: "Result 1", subtitle: "Subtitle 1" },
	{ title: "Result 2", subtitle: "Subtitle 2" },
	{ title: "Result 3", subtitle: "Subtitle 3" },
	{ title: "Result 4", subtitle: "Subtitle 4" },
];

export const SearchDrawer = () => {
	const closeMapTool = useCloseMapTool();
	const currentSearchInput = useCurrentSearchInput();
	const setCurrentSearchInput = useSetCurrentSearchInput();
	const currentSearchType = useCurrentSearchType();
	const setCurrentSearchType = useSetCurrentSearchType();

	return (
		<View
			onClose={closeMapTool}
			searchProps={{
				inputAutoFocus: true,
				currentInput: currentSearchInput,
				currentType: currentSearchType,
				onInputClear: () => setCurrentSearchInput(""),
				onInputChange: (value) => setCurrentSearchInput(value),
				onTypeChange: setCurrentSearchType,
			}}
			searchResults={currentSearchInput.length ? RESULTS : []}
		/>
	);
};
